
export const SET_STRATEGY_TASK_LIST = "SET_STRATEGY_TASK_LIST"
export const SET_ESG_STRATEGY_SELECTED_TASK = "SET_ESG_STRATEGY_SELECTED_TASK"
export const SET_STRATEGY_FREQUENCY_RANGE = "SET_STRATEGY_FREQUENCY_RANGE"
export const SET_STRATEGY_TASK_TOPIC_LIST = "SET_STRATEGY_TASK_TOPIC_LIST"
export const SET_CATEGORY_TOPIC = "SET_CATEGORY_TOPIC"